import * as React from 'react'
import { Link } from 'react-router-dom'
import ListColumnsMenu from '../ui/ListColumnsMenu'
import Dots from '../icons/ui/Dots'
import PencilIcon from '../icons/ui/Pencil'
import TrashIcon from '../icons/ui/Trash'

interface IMobilityDeviceActionProps {
  id: string | number
}

class MobilityItemDeviceAction extends React.Component<IMobilityDeviceActionProps> {
  public render() {
    return (
      <ListColumnsMenu icon={<Dots />}>
        <div className='flex flex-column' style={{ width: '200px' }}>
          <Link className='p2 flex items-center' to={`/global-settings/mobility-devices/edit/${this.props.id}`}>
            <PencilIcon className='icon--small svg-fill-grey mr2' />
            <span>Edit</span>
          </Link>
          <Link className='p2 flex items-center' to={`/global-settings/mobility-devices/remove/${this.props.id}`}>
            <TrashIcon className='icon--small svg-fill-grey mr2' />
            <span>Remove</span>
          </Link>
        </div>
      </ListColumnsMenu>
    )
  }
}

export default MobilityItemDeviceAction



// WEBPACK FOOTER //
// ./src/components/global-settings/MobilityDevicesItemAction.tsx